export default class SettingsService {
  static apiUrl = process.env.API_URL
  static siteUrl = process.env.SITE_URL
  static siteTitle = process.env.SITE_TITLE
  static siteDivider = process.env.SITE_DIVIDER

  static pageTitle (pageTitle) {
    return pageTitle ? pageTitle + this.siteDivider + this.siteTitle : this.siteTitle
  }
}



// WEBPACK FOOTER //
// ./src/services/SettingsService.js